import { render, staticRenderFns } from "./EditRules.vue?vue&type=template&id=8fe9db2a&scoped=true&"
import script from "./EditRules.vue?vue&type=script&lang=js&"
export * from "./EditRules.vue?vue&type=script&lang=js&"
import style0 from "./EditRules.vue?vue&type=style&index=0&id=8fe9db2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe9db2a",
  null
  
)

export default component.exports